import { Role } from "../enums/role";

export function canDeleteMediaFolder(userRole: Role): boolean {
    if (userRole === Role.SUPER_ADMIN || userRole === Role.SYSTEM_ADMIN) {
        return true;
    }

    return false;
}